export const aerialView = 'AerialView'
export const distributionMap = 'DistributionMap'



// WEBPACK FOOTER //
// ./src/pages/venue/constant/NavConstant.js